import { useQuery } from '@tanstack/react-query';
import { ActiveUsersApiResponse } from "../../pages/Analytics";
import { IStartEndBody } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetActiveUsersData = ({
  startDate = "7daysAgo",
  endDate = "today",
}: IStartEndBody) =>
  useQuery({
    queryKey: ["get_active_users_data", startDate, endDate],
    queryFn: async (): Promise<ActiveUsersApiResponse> => {

      const res = await apiClient.post(ENDPOINTS.ANALYTICS.GET_ACTIVE_USERS, {
        dimensions: ["date"],
        metrics: ["activeUsers"],
        dateRanges: [{ startDate, endDate }],
      });
      return res.data;
    },
  });